import React, { createRef, useEffect, useState } from "react";
import Button from "./button";
import SpeechBubble, { SpeechBubbleOrientation, SpeechBubblePosition } from "./speechBubble";
import { wrap } from "module";
import AccordionIcon from "../assets/icons/instruments/accordionIcon";
import InfoIcon from "../assets/icons/infoIcon";

interface ButtonWithSpeechBubbleProps {
    onClick: () => void;
    children: any;
    loading?: boolean;
    bubbleText: string;
    disabled?: boolean;
}

class ButtonWithSpeechBubbleSpeechBubbleProps {
    text: string;
    open: boolean;
    updateOpen: (v: boolean) => void;

    constructor(text: string, open: boolean, updateOpen: (v: boolean) => void) {
        this.text = text;
        this.open = open;
        this.updateOpen = updateOpen;
    }
}

export {ButtonWithSpeechBubbleSpeechBubbleProps}

export default function ButtonWithSpeechBubble(props: ButtonWithSpeechBubbleProps) {

    const [open, setOpen] = useState(false);

    const [bubbleX, setBubbleX] = useState(0);
    const [bubbleY, setBubbleY] = useState(0);

    const bubbleRef = createRef<HTMLDivElement>();
    const wrapperRef = createRef<HTMLDivElement>();

    function checkClick(event: Event) {
        if(!bubbleRef.current?.contains( event.target as Node ) && !wrapperRef.current?.contains( event.target as Node ) ){
            setOpen(false);
        }
    }

    useEffect(() => {
        window.addEventListener("click", checkClick);
        return () => {
            window.removeEventListener("click", checkClick);
        }
    })

    return <div ref={wrapperRef} className="button-speech-bubble-wrapper">
        <SpeechBubble ref={bubbleRef} text={open ? props.bubbleText : ""} icon={<InfoIcon/>} position={new SpeechBubblePosition(bubbleX, bubbleY, SpeechBubbleOrientation.CENTER)}/>
        <Button disabled={props.disabled} updatePosition={(x: number, y: number, width: number, height: number) => {
            setBubbleX(x + width/2);
            setBubbleY(y + height);
        }} loading={props.loading} onClick={() => {
            if(!props.disabled) {
                props.onClick();
            }else {
                setOpen(true);
            }
        }} children={props.children}/>
    </div>

}